import { render, staticRenderFns } from "./RegisterV1.vue?vue&type=template&id=b1b8c164"
import script from "./RegisterV1.vue?vue&type=script&lang=js"
export * from "./RegisterV1.vue?vue&type=script&lang=js"
import style0 from "./RegisterV1.vue?vue&type=style&index=0&id=b1b8c164&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports